import Modal, { ModalBody, ModalFooter } from "@components/ui/Modal";
import Button from "@components/ui/Button";

function formatDate(iso) {
  if (!iso) return "-";
  return new Date(iso).toLocaleString(undefined, {
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

function formatDuration(seconds) {
  if (!seconds && seconds !== 0) return "-";
  const m = Math.floor(seconds / 60);
  const s = seconds % 60;
  return `${m}:${String(s).padStart(2, "0")}`;
}

export default function MatchConfirmModal({
  show,
  onClose,
  onConfirm,
  appointment,
  callLog,
  loading,
}) {
  return (
    <Modal show={show} onClose={onClose} title="Confirm Match" size="lg">
      <ModalBody>
        <p className="text-sm text-gray-600 mb-4">
          Are you sure you want to match this appointment with this call log?
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          {/* Appointment side */}
          <div className="border rounded-lg p-4 bg-gray-50">
            <h4 className="text-xs font-semibold text-gray-500 uppercase mb-2">
              Appointment
            </h4>
            {appointment ? (
              <>
                <p className="text-sm font-medium">{appointment.patient_name}</p>
                <p className="text-xs text-gray-500 mt-1">
                  Created: {formatDate(appointment.created_at)}
                </p>
                <p className="text-xs text-gray-500">
                  Status: {appointment.status || "-"}
                </p>
                <p className="text-xs text-gray-500">
                  Phone: {appointment.phone_number || appointment.callback_phone_number || "-"}
                </p>
              </>
            ) : (
              <p className="text-sm text-gray-400">No appointment selected</p>
            )}
          </div>

          {/* Call log side */}
          <div className="border rounded-lg p-4 bg-gray-50">
            <h4 className="text-xs font-semibold text-gray-500 uppercase mb-2">
              Call Log
            </h4>
            {callLog ? (
              <>
                <p className="text-sm font-medium">{callLog.from_number}</p>
                <p className="text-xs text-gray-500 mt-1">
                  {formatDate(callLog.call_datetime)}
                </p>
                <p className="text-xs text-gray-500">
                  Duration: {formatDuration(callLog.call_duration_seconds)}
                </p>
              </>
            ) : (
              <p className="text-sm text-gray-400">No call log selected</p>
            )}
          </div>
        </div>
      </ModalBody>
      <ModalFooter className="flex justify-end gap-2">
        <Button color="light" size="sm" onClick={onClose} disabled={loading}>
          Cancel
        </Button>
        <Button size="sm" onClick={onConfirm} disabled={loading}>
          {loading ? "Matching..." : "Confirm Match"}
        </Button>
      </ModalFooter>
    </Modal>
  );
}
